import React, {useState, useEffect} from 'react'

import classes from './ScoreBar.module.css'
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { FaPlay } from 'react-icons/fa6';
import Chapter from '@/js/Chapter';
import Star from '@/components/shared/Star/Star';
import CountUp from 'react-countup';

import star_bronze from "../../screens/ScreenModules/star_bronze.png"
import star_silver from "../../screens/ScreenModules/star_silver.png"
import star_gold from "../../screens/ScreenModules/star_gold.png"

/**
 *
 * @param {{chapter : Chapter}} param0
 * @returns
 */
const ScoreBar = ({chapter}) => {

  // const [currentProgress, setCurrentProgress] = useState(0);

  let stars = chapter.stars
  let maxStars = chapter.maxStars
  let ratioProgress = stars / maxStars
  let percentCompleted = (ratioProgress * 100) + "%"

  let starPalier1 = parseInt(chapter.starsThreshold1)
  let starPalier2 = parseInt(chapter.starsThreshold2)
  let starPalier3 = parseInt(chapter.starsThreshold3)
  let paliers = [starPalier1, starPalier2, starPalier3]

  let currentPalier = 0
  if (stars >= chapter.starsThreshold3)
    currentPalier = 3
  else if (stars >= chapter.starsThreshold2)
    currentPalier = 2
  else if (stars >= chapter.starsThreshold1)
    currentPalier = 1

  return (
    <div className={classes.ScoreBar} style={{"--percentCompleted": percentCompleted}}>
      <div className={classes.progress_container}>
        <div className={classes.progress} style={{"--percentCompleted": percentCompleted}} >
          <div className={classes.progress_bar} />
        </div>
        <div className={classes.progress_paliers}>
          {paliers.map((p, index) =>
            <div key={p}  className={clsx(classes.palier, classes["threshold_"+(index+1)], p < stars && classes.active, p === stars && classes.hidden)}
            style={{"--percent": (p/maxStars*100)+"%"}} >
              <div className={classes.star_img}>
                {index === 0 && <img src={star_bronze} />}
                {index === 1 && <img src={star_silver} />}
                {index === 2 && <img src={star_gold} />}
              </div>
              <span>{p}</span>
            </div>
          )}
        </div>
      </div>
      <div className={clsx(classes.txt, classes["threshold_"+currentPalier])}  >
        <CountUp end={stars} duration={2} />
        {currentPalier === 0 ?
          <div className={classes.star}><Star /></div> :
          <div className={classes.star_img_bis}>
            {currentPalier === 1 && <img src={star_bronze} />}
            {currentPalier === 2 && <img src={star_silver} />}
            {currentPalier === 3 && <img src={star_gold} />}
          </div>}
      </div>
    </div>
  );
};

export default observer(ScoreBar)
